import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzTypographyModule } from 'ng-zorro-antd/typography';

import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';

import { EventSubmissionInstructionsDialogService } from '@main-client/src/app/events/event-submission-instructions-dialog/event-submission-instructions-dialog.service';

import { EventSubmissionInstructionsDialogComponent } from './event-submission-instructions-dialog.component';

@NgModule({
  declarations: [EventSubmissionInstructionsDialogComponent],
  exports: [EventSubmissionInstructionsDialogComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    NzTypographyModule,
    ReactiveFormsModule,
    TtcMatInputModule,
  ],
  providers: [EventSubmissionInstructionsDialogService],
})
export class EventSubmissionInstructionsDialogModule {}
